import {PaginationTrayResult} from "../../services/interface/trays/pagination-tray-result";
import {ResultTray} from "../../services/interface/trays/result-tray";

export const ResultAnalysisMock: ResultTray = {
    id:1,
    score: 'A1',
    scoreResult: 0.80,
    mail: 'example@gmail.com',
    calculation: 'Calculado',
    identification: '0106852981',
    names: 'Pedro Mateo Perez Bravo',
    creationDate: new Date('2024-01-25T12:00:00'),
}

export const ListTraysApprovedMock: PaginationTrayResult = {
    content: [
        {
            id:1,
            score: 'A1',
            scoreResult: 0.80,
            mail: 'example@gmail.com',
            calculation: 'Calculado',
            identification: '0106852981',
            names: 'Pedro Mateo Perez Bravo',
            creationDate: new Date('2024-01-25T12:00:00'),
        },
        {
            id:2,
            score: 'A3',
            scoreResult: 0.60,
            mail: 'example@gmail.com',
            calculation: 'No calculado',
            identification: '0109822985',
            names: 'Mario Humberto Lucero Bravo',
            creationDate: new Date('2024-01-25T12:10:00'),
        },
        {
            id:3,
            score: 'A2',
            scoreResult: 0.50,
            mail: 'example@gmail.com',
            calculation: 'Calculado',
            identification: '0104822984',
            names: 'Luis Pedro Avila Lopez',
            creationDate: new Date('2024-01-25T12:30:00'),
        },
    ],
    pageable: {
        pageNumber: 0,
        pageSize: 10,
        sort: {
            empty: true,
            sorted: false,
            unsorted: true
        },
        offset: 0,
        paged: true,
        unpaged: false
    },
    last: true,
    totalPages: 15,
    totalElements: 80,
    size: 10,
    number: 10,
    sort: {
        empty: true,
        sorted: false,
        unsorted: true
    },
    first: true,
    numberOfElements: 4,
    empty: false
}

export const ListTraysPendingMock: PaginationTrayResult = {
    content: [
        {
            id:1,
            score: 'B2',
            scoreResult: 0.80,
            mail: 'example@gmail.com',
            calculation: 'Calculado',
            identification: '0106852981',
            names: 'Pedro Mateo Perez Bravo',
            creationDate: new Date('2024-01-25T12:00:00'),
        },
        {
            id:2,
            score: 'C1',
            scoreResult: 0.60,
            mail: 'example@gmail.com',
            calculation: 'No calculado',
            identification: '0109822985',
            names: 'Mario Humberto Lucero Bravo',
            creationDate: new Date('2024-01-25T12:10:00'),
        },
        {
            id:3,
            score: 'C2',
            scoreResult: 0.50,
            mail: 'example@gmail.com',
            calculation: 'Calculado',
            identification: '0104822984',
            names: 'Luis Pedro Avila Lopez',
            creationDate: new Date('2024-01-25T12:30:00'),
        },
    ],
    pageable: {
        pageNumber: 0,
        pageSize: 10,
        sort: {
            empty: true,
            sorted: false,
            unsorted: true
        },
        offset: 0,
        paged: true,
        unpaged: false
    },
    last: true,
    totalPages: 15,
    totalElements: 80,
    size: 10,
    number: 10,
    sort: {
        empty: true,
        sorted: false,
        unsorted: true
    },
    first: true,
    numberOfElements: 4,
    empty: false
}
export const ListTraysDeniedMock: PaginationTrayResult = {
    content: [
        {
            id:1,
            score: 'D',
            scoreResult: 0.80,
            mail: 'example@gmail.com',
            calculation: 'Calculado',
            identification: '0106852981',
            names: 'Pedro Mateo Perez Bravo',
            creationDate: new Date('2024-01-25T12:00:00'),
        },
        {
            id:2,
            score: 'D',
            scoreResult: 0.60,
            mail: 'example@gmail.com',
            calculation: 'No calculado',
            identification: '0109822985',
            names: 'Mario Humberto Lucero Bravo',
            creationDate: new Date('2024-01-25T12:10:00'),
        },
        {
            id:3,
            score: 'AL',
            scoreResult: 0.50,
            mail: 'example@gmail.com',
            calculation: 'Calculado',
            identification: '0104822984',
            names: 'Luis Pedro Avila Lopez',
            creationDate: new Date('2024-01-25T12:30:00'),
        },
    ],
    pageable: {
        pageNumber: 0,
        pageSize: 10,
        sort: {
            empty: true,
            sorted: false,
            unsorted: true
        },
        offset: 0,
        paged: true,
        unpaged: false
    },
    last: true,
    totalPages: 15,
    totalElements: 80,
    size: 10,
    number: 10,
    sort: {
        empty: true,
        sorted: false,
        unsorted: true
    },
    first: true,
    numberOfElements: 4,
    empty: false
}
